<template>
    <div class="home">
        <h1>This is Home Page</h1>
        <p @click="message">message</p>
        <p @click="prompt">prompt</p>
        <p @click="yesno">yes / no</p>
    </div>
</template>

<script>

import Alert from '@/utilities/Alert.js'

export default {
    methods: {
        message () {
            Alert.message('Hello There ???');
        },
        prompt () {
            Alert.prompt('Enter Some Value',value => {
                Alert.message('You Entered '+value)
            })
        },
        yesno () {
            Alert.yesno('Do you want more chips',yes => {
                yes ? Alert.message('OK, you get chips') : Alert.message('No chips for you then');
            })
        }
    }
}

</script>
